/*
 * Lemonade Training Oy, copy rights, all right reserved.
 *
 * The dunning copy deck. Shared string for string with the mobile app, so a
 * member reads the same words on both surfaces. No em dashes anywhere here.
 */

import { PAYMENT_ISSUE_BADGE } from "../coach/rosterCopy";

export const DUNNING_GRACE_BODY = (date: string) =>
  `We couldn't process your last payment. No problem, we'll try again automatically, and your access is unaffected until ${date}. Want to fix it now?`;

export const DUNNING_GRACE_BODY_NO_DATE =
  "We couldn't process your last payment. No problem, we'll try again automatically, and your access is unaffected while we retry. Want to fix it now?";

export const DUNNING_PAUSED_TITLE = "Access paused";

export const DUNNING_PAUSED_BODY =
  "A payment didn't go through. Fix it and you're back in instantly. Nothing is lost.";

export const DUNNING_EXTENSION = (date: string) =>
  `While paused, your commitment end date moves out day for day (currently ${date}) so you keep the time you committed.`;

export const DUNNING_EXTENSION_NO_DATE =
  "While paused, your commitment end date moves out day for day so you keep the time you committed.";

export const DUNNING_CONTACT = "Questions? Contact your gym.";

export const DUNNING_CURED = "You're all set. Welcome back.";

export const UPDATE_PAYMENT_LABEL = "Update payment method";

export const CARD_UPDATE_TRY_AGAIN = "Try again";

export const CARD_UPDATE_FAILED_FALLBACK =
  "We couldn't open the card update page. Please try again in a moment.";

export const CARD_UPDATE_SUCCESS_TITLE = "Card saved.";

export const CARD_UPDATE_SUCCESS_BODY =
  "We're retrying the payment now. You'll see the outcome in the app within a few minutes.";

export const CARD_UPDATE_CANCEL_TITLE = "Nothing changed.";

export const CARD_UPDATE_CANCEL_BODY =
  "Your card on file is unchanged. You can try again from your membership.";

export const PAYMENT_STATUS_BADGE_GRACE = PAYMENT_ISSUE_BADGE;

export const PAYMENT_STATUS_BADGE_PAUSED = DUNNING_PAUSED_TITLE;
